import { Icon } from '@sunwebgroup/uds-ui/icon'
import { useIntl } from '@/intl'
import { Block, Header } from './Blocks'
import styles from './WebsiteOfTheYearAward.module.css'

interface WebsiteOfTheYearAwardProps {
  className?: string
}

export function WebsiteOfTheYearAward({ className }: WebsiteOfTheYearAwardProps) {
  const intl = useIntl()
  const title = intl.formatMessage({ id: 'footer_website_of_the_year_title' })

  return (
    <Block className={className}>
      <Header>{title}</Header>
      <a href="https://www.websitevhjaar.nl/" aria-label={title}>
        <Icon
          glyph="WebsiteBadgeCertified"
          className={styles.icon}
          aria-hidden="true"
        />
      </a>
    </Block>
  )
}
